﻿/* lg-readmore.js — C17 (25 Aug). The brand_story custom_liquid calls
   myFunctionOne() but live never shipped it; the ellipsis and the full
   text both rendered. Collapsed by default, toggle on tap/click. */
(function () {
  function init() {
    var dots = document.getElementById('dotsOne');
    var more = document.getElementById('moreOne');
    var btn = document.getElementById('myBtnOne');
    if (!dots || !more || !btn) return;
    more.style.display = 'none';
    dots.style.display = 'inline';
    window.myFunctionOne = function () {
      var open = more.style.display !== 'none';
      more.style.display = open ? 'none' : 'inline';
      dots.style.display = open ? 'inline' : 'none';
      btn.textContent = open ? 'Read More' : 'Read Less';
    };
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
